<xt-ui-kit-dialog *transloco="let t" [config]="dialogConfig" [actionsTemplate]="actions">
  <div>
    @if (data.content) {
      <div class="dialog-content">
        {{ t(data.content) }}
      </div>
    }
    @if (data.contentHTML) {
      <div
        mat-dialog-content
        class="dialog-content"
        [innerHTML]="t(data.contentHTML)"
      ></div>
    }
    <ng-template #actions>
      <xt-portal-dialog-footer
        [cancelBtnText]="t(data.cancelBtnText)"
        [confirmBtnText]="t(data.confirmBtnText)"
        [dataCy]="data.dataCy"
        (closeDialog)="closeDialog(false)"
        (confirm)="closeDialog(true)"
      />
    </ng-template>
  </div>
</xt-ui-kit-dialog>